
import React, { useRef, useState, useEffect } from 'react';

export default function DraggableResizableModal({ isOpen, onClose, title, children, minWidth=400, minHeight=300, initialWidth=600, initialHeight=400 }) {
  // Hook'lar koşulsuz çağrılır
  const [pos, setPos] = useState({ x: 0, y: 0 });
  const [size, setSize] = useState({ width: initialWidth, height: initialHeight });
  const [dragging, setDragging] = useState(false);
  const [resizing, setResizing] = useState(false);
  const dragStart = useRef({ x:0, y:0 });
  const sizeStart = useRef({ width:0, height:0, x:0, y:0 });

  // Modal ilk açıldığında ortala
  useEffect(() => {
    if (isOpen) {
      setPos({ x: window.innerWidth/2 - initialWidth/2, y: window.innerHeight/2 - initialHeight/2 });
      setSize({ width: initialWidth, height: initialHeight });
    }
    // eslint-disable-next-line
  }, [isOpen, initialWidth, initialHeight]);



  const onMouseDownDrag = e => {
    setDragging(true);
    dragStart.current = { x: e.clientX - pos.x, y: e.clientY - pos.y };
    document.body.style.userSelect = 'none';
  };
  const onMouseDownResize = e => {
    setResizing(true);
    sizeStart.current = { width: size.width, height: size.height, x: e.clientX, y: e.clientY };
    document.body.style.userSelect = 'none';
    e.stopPropagation();
  };
  React.useEffect(() => {
    const onMove = e => {
      if (dragging) setPos({ x: e.clientX - dragStart.current.x, y: e.clientY - dragStart.current.y });
      if (resizing) setSize({
        width: Math.max(minWidth, sizeStart.current.width + (e.clientX - sizeStart.current.x)),
        height: Math.max(minHeight, sizeStart.current.height + (e.clientY - sizeStart.current.y))
      });
    };
    const onUp = () => { setDragging(false); setResizing(false); document.body.style.userSelect = ''; };
    if (dragging || resizing) {
      window.addEventListener('mousemove', onMove);
      window.addEventListener('mouseup', onUp);
      return () => {
        window.removeEventListener('mousemove', onMove);
        window.removeEventListener('mouseup', onUp);
      };
    }
  }, [dragging, resizing]);

  return (
    <div style={{
      display: isOpen ? 'flex' : 'none',
      position:'fixed', inset:0, zIndex:300, background:'rgba(0,0,0,0.55)', alignItems:'center', justifyContent:'center'
    }}>
      <div style={{ position:'absolute', inset:0 }} onClick={onClose} />
      <div style={{
        position:'absolute',
        left:pos.x, top:pos.y,
        width:size.width, height:size.height,
        background:'#1e293b', color:'#fff', borderRadius:14, boxShadow:'0 16px 48px #000a',
        border:'1.5px solid #334155', display:'flex', flexDirection:'column',
        minWidth, minHeight, userSelect:'none',
      }}>
        <div style={{ cursor:'move', padding:'12px 18px', fontWeight:700, fontSize:16, borderBottom:'1px solid #334155', background:'#273449', borderTopLeftRadius:14, borderTopRightRadius:14, display:'flex', alignItems:'center', justifyContent:'space-between' }}
          onMouseDown={onMouseDownDrag}>
          <span>{title}</span>
          <button onClick={onClose} style={{ background:'none', border:'none', color:'#fff', fontSize:20, cursor:'pointer', marginLeft:8 }}>&times;</button>
        </div>
        <div style={{ flex:1, overflow:'auto', padding:18 }}>{children}</div>
        <div onMouseDown={onMouseDownResize} style={{ position:'absolute', right:0, bottom:0, width:22, height:22, cursor:'nwse-resize', zIndex:2 }}>
          <svg width="22" height="22"><polyline points="0,22 22,0" stroke="#64748b" strokeWidth="2" /></svg>
        </div>
      </div>
    </div>
  );
}
